import { LetteredUserCircle } from "Components";
import { FC, useCallback, useEffect, useState } from "react";
import { TSavedQueryTempDTO } from "Types";

// styles
import styles from "./queryTabsOpenMenu.module.scss";

type TQueryTabsOpenMenuProps = {
    savedQueries: TSavedQueryTempDTO[],
    openQueryIds: Set<string>,
    loadQuery: (queryId: string) => void
}

export const QueryTabOpenMenu: FC<TQueryTabsOpenMenuProps> = ({ savedQueries, openQueryIds, loadQuery }: TQueryTabsOpenMenuProps) => {

    const getQueries = useCallback((doGetOwnedQueries: boolean) => {
        return savedQueries.filter((query) => { 
            if(openQueryIds.has(query.guid)) return false;
            return doGetOwnedQueries ? query.isOwnedByCurrentUser : !query.isOwnedByCurrentUser; 
        });
    }, [savedQueries, openQueryIds]);

    // State
    const [ownQueries, setOwnQueries] = useState<TSavedQueryTempDTO[]>(getQueries(true));
    const [otherUserQueries, setOtherUserQueries] = useState<TSavedQueryTempDTO[]>(getQueries(false));

    useEffect(() => {
        setOwnQueries(getQueries(true));
        setOtherUserQueries(getQueries(false));

    }, [savedQueries, getQueries]);

    return (
        <div className={styles.queryTabsOpenMenu}>
            <div className={[styles.menuContent, styles.scrollbarCustomThin].join(" ")}>
                {savedQueries.length !== openQueryIds.size ?
                    <div>
                        {ownQueries.length > 0 ? 
                            <div>
                                <div><span className={styles.querySeperatorText}>Your queries ({ownQueries.length})</span></div>
                                {ownQueries.map((query) => {
                                    return (
                                        <div key={query.guid} onClick={() => { loadQuery(query.guid); }} className={styles.queryItem}>
                                            <span className={styles.queryName} title={query.name}>{query.name}</span>
                                        </div>
                                    );
                                })}
                            </div>
                            : null }
                        {otherUserQueries.length > 0 ?
                            <div>
                                <div><span className={styles.querySeperatorText}>Other user's queries ({otherUserQueries.length})</span></div>
                                {otherUserQueries.map((query) => {
                                    return (
                                        <div key={query.guid} onClick={() => { loadQuery(query.guid); }} className={styles.queryItem}>
                                            <LetteredUserCircle className={styles.smallLetterIcon} username={query.username} />
                                            <span className={styles.queryName} title={query.name}>{query.name}</span>
                                        </div>
                                    );
                                })}
                            </div>
                            : null}
                    </div>
                    : <div className={styles.noQueriesLeft}>No queries left to load</div>}
            </div>
        </div>
    );
};